import * as Yup from 'yup';
import { useState, useContext } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
// material
import { Link, Stack, Checkbox, TextField, IconButton, InputAdornment, FormControlLabel, Alert } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';

// component
import Theme from '../../../components/Button';
import Iconify from '../../../components/Iconify';
// context
import { AuthContext } from '../../../contexts/auth';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const { login } = useContext(AuthContext);

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    usuario: Yup.string().required('Usuário é obrigatório'),
    senha: Yup.string().required('Senha é obrigatória'),
  });

  const formik = useFormik({
    initialValues: {
      usuario: '',
      senha: '',
      remember: true,
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      navigate('/indicadores', { replace: true });
    },
  });

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  })
   
  const handleSubmit = async (e) => {
     e.preventDefault();
     
     const retorno = await login(formik.values.usuario, formik.values.senha);
     
     if (retorno) {
        if(retorno.erro === true) {
            setStatus({
              type: 'erro',
              mensagem: retorno.mensagem
            })
        } 
     }

  }  

  const { errors, touched, values, isSubmitting, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="username"
            label="Usuário"
            {...getFieldProps('usuario')}
            error={Boolean(touched.usuario && errors.usuario)}
            helperText={touched.usuario && errors.usuario}
          />

          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Senha"
            {...getFieldProps('senha')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleShowPassword} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={Boolean(touched.senha && errors.senha)}
            helperText={touched.senha && errors.senha}
          />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <FormControlLabel
            control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />}
            label="Lembrar Dados?"
          />
        </Stack>
        
        <Stack spacing={3}>
            {status.type === 'erro' ? <Alert severity="error">{status.mensagem}</Alert> : ""}
        </Stack>    
        
        <ThemeProvider theme={Theme}>
          <LoadingButton color="neutral" fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
            Entrar
          </LoadingButton>
        </ThemeProvider>
      </Form>
    </FormikProvider>
  );
}
